import { Reducer } from 'redux';
import { CMX__SET_BUNDLE } from './types';
import { CmxState } from './interfaces';

const cmxState: CmxState = {
    isBundleUpdating: false
};

export const cmxReducer: Reducer<CmxState> = (state = cmxState, action) => {
    switch (action.type) {
        case CMX__SET_BUNDLE:
            return {
                ...state,
                isBundleUpdating: action.updating
            };
        default:
            return state;
    }
};
